import ReconnectingWebSocket from 'reconnecting-websocket';

import { config } from "@/config";
import Bus from '@/core/bus';

import stateStore from '@/store';

import { bufferToHash, hex2buffer } from '@/helpers/utils';
import { toastError } from '@/helpers/toastify';
import { barcodesFind } from '@/api/barcodes';

//Использовать Bus
class WSLocalClient {
	private ws: any;

	constructor() {
		this.ws = new ReconnectingWebSocket(
			config.ws_local,
			[],
			{
				connectionTimeout: 10000,
				maxRetries: 1,
				startClosed: true
			}
		);

		this.ws.onopen = () => {
			stateStore.dispatch('onlineAgent', true);

			// Отправляем оборудование после подключения
			this.sendEquipment();
			
			// Запрашиваем список сканеров из Windows для автоматического определения
			this.send({ 'scanners': {} });
		};

		this.ws.onmessage = async (message: any) => {
			const json = JSON.parse(message.data);
			Bus.$emit('ws-local-data', json);

			if (json['barcode']) {
				const buffer = hex2buffer(json.barcode).filter((value: number) => value > 31);

				const hashBarcode = bufferToHash(buffer);

				if (stateStore.state.openDocument) {
					const data: any = await barcodesFind(hashBarcode)
					if (data.complete) {
						Bus.$emit('ws-open-document', data.data);
					} else {
						toastError(`Штрих-код "${buffer.toString()}" не найден в системе`);
					}
				}

				Bus.$emit('ws-barcode', buffer.toString());
			}

			if (json['equipment']) {
				// Создаем новый массив для реактивности Vue
				const updatedEquipment = [...stateStore.state.equipment];
				let changed = false;
				
				for (const item of json['equipment']) {
					for (let i = 0; i < updatedEquipment.length; i++) {
						const equipment: any = updatedEquipment[i];

						// Сравниваем ID как строки для надежности
						if (String(item['id']) === String(equipment['id'])) {
							const newActive = !!item['active'];
							if (equipment.active !== newActive) {
								updatedEquipment[i] = { ...equipment, active: newActive };
								changed = true;
					}
							break;
						}
					}
				}
				
				// Обновляем state только если были изменения
				if (changed) {
					stateStore.commit('equipment', updatedEquipment);
				}
			}
		}

		this.ws.onclose = () => {
			stateStore.dispatch('onlineAgent', false);
		}

		this.ws.onerror = (error: any) => {
			// Логи убраны по запросу пользователя
		}
	}

	send(message: any = {}) {
		if (!stateStore.state.onlineAgent) {
			return false;
		}

		// Если отправляется команда сканирования, эмитим событие для установки isScanning = true
		if (message && 'scan' in message) {
			Bus.$emit('scan-command-sent', message);
		}

		this.ws.send(JSON.stringify(message));
		return true;
	}

	sendEquipment() {
		const equipment = stateStore.state.equipment
			.filter((el: any) => [1, 2, 3, 4].includes(el.type))
			.map((el: any) => {
				// Преобразуем settings в числа, если это массив
				let settings = el.settings || [];
				if (Array.isArray(settings)) {
					settings = settings.map((s: any) => {
						// Преобразуем в число, если это строка с числом
						const num = typeof s === 'string' ? parseFloat(s) : s;
						return isNaN(num) ? s : num;
					});
				}
				
				return {
					id: el.id,
					type: el.type,
					settings: settings,
					// ВСЕГДА устанавливаем active: true при отправке в ScanAgent
					// ScanAgent сам определит реальный статус и отправит обратно
					active: true
				};
			});

		if (equipment.length > 0) {
			this.send({ equipment });
		}
	}

	open() {
		this.ws.reconnect();
	}
}

export default new WSLocalClient;
